/**
 * permissionUtils.ts
 *
 * Pure, dependency-free permission logic shared by PermissionsContext and its
 * tests. Kept separate from the .tsx so unit tests don't pull in React or the
 * Supabase client at import time (mirrors the codebase's "test the pure helper"
 * pattern, e.g. dialog.ts / isCancelInput).
 *
 * Mirrors the DB helper current_user_has_permission(text) from migration 0057:
 *   - a permission set containing the '*' sentinel grants EVERYTHING (super_admin);
 *   - otherwise the exact key must be present.
 * An empty set grants nothing — which is exactly the default-deny-while-loading
 * behavior the context relies on (permissions start empty until the fetch lands).
 */

/** The allow-all sentinel. Held only by super_admin (seeded in 0057). Reserved — never a real key. */
export const WILDCARD_PERMISSION = '*';

/**
 * Returns true if `perms` grants `key`.
 *   permissionGranted(set, key) === set.has('*') || set.has(key)
 * An empty set always returns false (default-deny).
 */
export function permissionGranted(perms: ReadonlySet<string>, key: string): boolean {
  return perms.has(WILDCARD_PERMISSION) || perms.has(key);
}
